import { CalendarCheck } from "lucide-react";
import QuickLogModal from "../QuickLogModal";

/**
 * Custom "Sessions Today" card — visually similar to StatCard but
 * surfaces a CTA when the count is 0, so it isn't a pure StatCard.
 */
export default function SessionsTodayCard({ count }) {
    return (
        <div
            className="bg-white rounded-3xl border border-mist card-soft p-6 sm:p-7 transition-all duration-300 hover:-translate-y-1"
            data-testid="stat-sessions-today"
        >
            <div className="flex items-start justify-between mb-4">
                <span className="text-[11px] font-bold uppercase tracking-[0.14em] text-slate-500">
                    Sessions Today
                </span>
                <div className="w-10 h-10 rounded-xl bg-brand-soft flex items-center justify-center">
                    <CalendarCheck
                        className="text-[#4A6F8F]"
                        size={20}
                        strokeWidth={2.5}
                    />
                </div>
            </div>
            <div className="font-display font-bold text-5xl sm:text-6xl leading-none text-slate-900">
                {count}
            </div>
            {count > 0 ? (
                <div className="mt-3 text-sm text-slate-500 font-medium">
                    Logged for today
                </div>
            ) : (
                <div className="mt-4">
                    <QuickLogModal
                        triggerClassName="inline-flex items-center rounded-lg bg-action-soft hover:bg-action-soft text-[#3D6385] font-bold h-9 px-3 text-xs"
                        triggerLabel="Start logging attendance"
                    />
                </div>
            )}
        </div>
    );
}
